import { BaseBusinessService } from "./base-business-service.ts"
import { SupportServiceInterface } from "../../../../interfaces/support-service.ts"

export class BusinessSupportService
    extends BaseBusinessService
    implements SupportServiceInterface
{
    useGetEnableVidAutocharge = () => {
        return this.get({ endpoint: "/enable-vid-autocharge" })
    }

    useEnableGdprMessage = () => {
        return this.get({ endpoint: "/message-customer-migration" })
    }
}
